<template>
  <ApplicationLayout
    :user="user"
    :options="options"
    :version="version"
    :links="links"
    :showActionItems="true"
  >
    <!-- Set System bar content if enabled-->
    <template #systembar> </template>

    <!-- Set Appbar title-->
    <template #title>
      <v-toolbar-title class="font-weight-bold d-flex">
        Aml Pro
      </v-toolbar-title>
      <v-icon small style="margin-top: -20px">mdi-apps</v-icon>
    </template>

    <!-- Use to add addition items to Appbar -->
    <template #toolbar>
      <ReportIssueButton />
      <NotificationMenu />
    </template>

    <!-- Use change Navbar header content-->
    <template #navheader> </template>

    <!-- Use display content-->
    <template #content>
      <router-view />
    </template>
  </ApplicationLayout>
</template>

<script>
import ApplicationLayout from '@/modules/shared/components/core/layouts/ApplicationLayout.vue';
import NotificationMenu from '@/modules/shared/components/core/NotificationMenu.vue';
import ReportIssueButton from '@/modules/shared/components/core/ReportIssueButton.vue';
import CoreMixin from '@/mixins/core.mixin';
import amlproLinks from '@/modules/amlpro/routes/links';

const layoutOptions = {
  showSystemBar: false,
  showSearchBar: false,
  showUserOptions: true,
  showMenuToggle: true,

  appBarColor: '#fafbfc',
  miniDrawerColor: '',
  miniDrawerIconsColor: 'white',
  leftDrawerColor: 'white',
  leftDrawerIconsColor: ''
};

export default {
  components: { ApplicationLayout, NotificationMenu, ReportIssueButton },
  mixins: [CoreMixin],
  data: () => ({
    options: layoutOptions,
    links: amlproLinks
  })
};
</script>
